import React, { Component } from 'react';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';
import { SwipeAction, Modal, Toast } from 'antd-mobile';
import { Icon } from 'antd';
import { Waypoint } from 'react-waypoint';
import { Element } from 'react-scroll';
import moment from 'moment';
import OverTimeMonthModel from '../static/OverTimeMonthModel';
import OvertimeAppMobileStore from '../stores/OvertimeAppMobileStore';
import StorageHelper from 'shared/utils/StorageHelper';
import AppConst from 'shared/utils/AppConst';
import MobileLanguageHelper from 'shared/utils/MobileLanguageHelper';

interface Props {
  overtimeAppMobileStore?: OvertimeAppMobileStore;
  overtimeItem: OverTimeMonthModel;
  history?: any;
  onChangeHeaderVisible: (a: boolean) => void;
}

const { alert } = Modal;

const CardWrapper = styled.div`
  background-color: #f3f3f4;
  border-bottom: 1px solid #e3e3e3;
  ::after {
    content: '';
    display: table;
    clear: both;
  }
  display: flex;
  justify-content: flex-start;
`;

const LeftDiv = styled.div`
  /* float: left; */
  width: 80px;
  padding: 10px 20px;
  text-align: right;
`;

const Date = styled.div`
  width: 30px;
  display: inline-block;
`;

const DateRender = styled.div<{ weekend?: any }>`
  color: ${props => (props.weekend === 'Y' ? '#e50505' : '#000000')};
  font-size: 20px;
`;

const YearMonthRender = styled.div`
  font-size: 12px;
  white-space: nowrap;
`;

const RightDiv = styled.div`
  /* float: left; */
  padding: 10px;
  flex: 1;
`;

const WeekName = styled.div`
  font-size: 12px;
`;

const OvertimeCardAppr = styled.div<{ sts?: string | null; type?: string }>`
  color: ${props => (props.sts === 'S' ? '#ffffff' : props.type === 'OT' ? '#7b7cb4' : '#77a16f')};
  /* margin-bottom: 5px; */
  padding: 10px;
  height: 84px;
  /* background-color: #ffffff; */
  background-color: ${props => (props.sts === 'S' ? (props.type === 'OT' ? '#7b7cb4' : '#77a16f') : '#ffffff')};
  position: relative;
`;

const OvertimeCardReg = styled.div<{ sts?: string | null; type?: string }>`
  color: ${props => (props.type === 'OT' ? '#7b7cb4' : '#77a16f')};
  /* margin-bottom: 5px; */
  padding: 10px;
  height: 84px;
  /* background-color: #ffffff; */
  background-color: ${props => (props.sts === '1' ? '#ffffff' : props.sts === 'R' ? '#bdbec2' : '#ffffff')};
  position: relative;

  border: 1px solid ${props => (props.type === 'OT' ? '#7b7cb4' : '#77a16f')};
`;

const OvertimeCardHeader = styled.div`
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
`;

const PjCodeRender = styled.div`
  font-size: 14px;
  margin-top: 4px;
`;

const PjNameEllipsis = styled.div`
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 1.4em;
  height: 1.4em;
  width: 70%;
`;

const ApprStsRender = styled.div<{ sts?: string | null }>`
  font-size: 12px;
  position: absolute;
  right: 20px;
  bottom: 10px;
  text-align: right;
`;

const RenderHours = styled.div<{ type?: string; sts?: string | null }>`
  position: absolute;
  right: 20px;
  top: 0px;
  font-weight: 700;
  font-size: 34px;
  color: ${props => (props.sts === 'S' ? '#ffffff' : props.type === 'OT' ? '#7a7bb3' : props.type === 'AB' ? '#77a16f' : '#a7a8ac')};
`;

const InfoArrow = styled.div<{ visible?: boolean }>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 8px;
  font-weight: 700;
  font-size: 14px;
  color: rgb(0, 0, 0, 0.5);
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

@inject('overtimeAppMobileStore')
@observer
export default class AppDetailMobileCardComponent extends Component<Props> {
  state = {
    infoArrowVisible: false,
    modal: false,
    modalContents: ''
  };

  onModalOpen = (response: any) => {
    this.setState({
      modal: true,
      modalContents: response
    });
  };

  onModalClose = () => {
    this.setState({
      modal: false
    });
  };

  rejectOvertime = (overtimeItem: OverTimeMonthModel) => {
    if (this.props.overtimeAppMobileStore!.getOverTimeCheck(overtimeItem.overTimeType, overtimeItem.overtimeWorkHours, overtimeItem.overTimeYmd) === 'weekOver') {
      // Toast.fail(`${overtimeItem.workSysMonthWeekly}${MobileLanguageHelper.getMessage('overtime.validation.message.weekexceed')}`, 2);
      this.onModalOpen(`${overtimeItem.workSysMonthWeekly}${MobileLanguageHelper.getMessage('overtime.validation.message.weekexceed')}`);
      return;
    }
    if (this.props.overtimeAppMobileStore!.getOverTimeCheck(overtimeItem.overTimeType, overtimeItem.overtimeWorkHours, overtimeItem.overTimeYmd) === 'monthOver') {
      // Toast.fail(MobileLanguageHelper.getMessage('overtime.validation.message.monthexceed'), 2);
      this.onModalOpen(MobileLanguageHelper.getMessage('overtime.validation.message.monthexceed'));
      return;
    }

    overtimeItem.apprSts = 'R';
    this.props.overtimeAppMobileStore!.updateOverTime(overtimeItem).then(() => {
      Toast.success(MobileLanguageHelper.getMessage('overtime.toast.message.reject'), 2);
    });
  };

  apprOvertime = (overtimeItem: OverTimeMonthModel) => {
    if (this.props.overtimeAppMobileStore!.getOverTimeCheck(overtimeItem.overTimeType, overtimeItem.overtimeWorkHours, overtimeItem.overTimeYmd) === 'weekOver') {
      // Toast.fail(`${overtimeItem.workSysMonthWeekly}${MobileLanguageHelper.getMessage('overtime.validation.message.weekexceed')}`, 2);
      this.onModalOpen(`${overtimeItem.workSysMonthWeekly}${MobileLanguageHelper.getMessage('overtime.validation.message.weekexceed')}`);
      return;
    }
    if (this.props.overtimeAppMobileStore!.getOverTimeCheck(overtimeItem.overTimeType, overtimeItem.overtimeWorkHours, overtimeItem.overTimeYmd) === 'monthOver') {
      // Toast.fail(MobileLanguageHelper.getMessage('overtime.validation.message.monthexceed'), 2);
      this.onModalOpen(MobileLanguageHelper.getMessage('overtime.validation.message.monthexceed'));
      return;
    }
    overtimeItem.apprSts = 'S';
    this.props.overtimeAppMobileStore!.updateOverTime(overtimeItem).then(() => {
      Toast.success(MobileLanguageHelper.getMessage('overtime.toast.message.approval'), 2);
    });
  };

  onClickRegCard = () => {
    this.setState({
      infoArrowVisible: true
    });

    setTimeout(() => {
      this.setState({
        infoArrowVisible: false
      });
    }, 1000);
  };

  calendarCreateInput = (overtimeItem: OverTimeMonthModel): JSX.Element => {
    return (
      <SwipeAction
        style={{ backgroundColor: 'gray', marginBottom: '5px' }}
        autoClose
        left={[
          {
            text: MobileLanguageHelper.getMessage('overtime.button.title.reject'),
            onPress: () =>
              alert(MobileLanguageHelper.getMessage('overtime.button.title.reject'), MobileLanguageHelper.getMessage('overtime.confirm.message.reject'), [
                { text: MobileLanguageHelper.getMessage('overtime.button.title.cancel') },
                { text: MobileLanguageHelper.getMessage('overtime.button.title.reject'), onPress: () => this.rejectOvertime(overtimeItem) }
              ]),
            style: { backgroundColor: '#F4333C', color: 'white', width: '70px' }
          }
        ]}
        right={[
          {
            text: MobileLanguageHelper.getMessage('overtime.button.title.approval'),
            onPress: () =>
              alert(MobileLanguageHelper.getMessage('overtime.button.title.approval'), MobileLanguageHelper.getMessage('overtime.confirm.message.approval'), [
                { text: MobileLanguageHelper.getMessage('overtime.button.title.cancel') },
                { text: MobileLanguageHelper.getMessage('overtime.button.title.approval'), onPress: () => this.apprOvertime(overtimeItem) }
              ]),
            style: { backgroundColor: '#108ee9', color: 'white', width: '70px' }
          }
        ]}
        //onOpen={() => console.log("global open")}
        //onClose={() => console.log("global close")}
      >
        <OvertimeCardReg sts={overtimeItem.apprSts} type={overtimeItem.overTimeType} onClick={this.onClickRegCard}>
          <OvertimeCardHeader>
            <div>
              {overtimeItem.overTimeType === 'OT'
                ? MobileLanguageHelper.getMessage('overtime.button.title.overtime')
                : overtimeItem.overTimeType === 'AB'
                ? MobileLanguageHelper.getMessage('overtime.button.title.alterbreak')
                : ''}
            </div>
            {/* <div>{overtimeItem.overtimeWorkHours} 시간</div> */}
          </OvertimeCardHeader>
          <PjCodeRender>{overtimeItem.pjCode}</PjCodeRender>
          <PjNameEllipsis>{overtimeItem.pjName}</PjNameEllipsis>

          <RenderHours type={overtimeItem.overTimeType} sts={overtimeItem.apprSts}>
            {overtimeItem.overtimeWorkHours}
          </RenderHours>
          <ApprStsRender sts={overtimeItem.apprSts}>
            {overtimeItem.apprSts === '1'
              ? MobileLanguageHelper.getMessage('overtime.card.status.writing')
              : overtimeItem.apprSts === 'R'
              ? MobileLanguageHelper.getMessage('overtime.card.status.reject')
              : overtimeItem.apprSts === 'A'
              ? MobileLanguageHelper.getMessage('overtime.card.status.apprreq')
              : overtimeItem.apprSts === 'S'
              ? MobileLanguageHelper.getMessage('overtime.card.status.apprcomp')
              : ''}
          </ApprStsRender>
          <InfoArrow visible={this.state.infoArrowVisible}>
            <span style={{ color: 'rgb(0,0,255,0.5)' }}>
              <Icon type="double-left" />
              <Icon type="double-left" />
              <Icon type="double-left" />
            </span>
            {'  '}
            swipe{'  '}
            <span style={{ color: 'rgb(255,0,0,0.5)' }}>
              <Icon type="double-right" />
              <Icon type="double-right" />
              <Icon type="double-right" />
            </span>
          </InfoArrow>
        </OvertimeCardReg>
      </SwipeAction>
    );
  };

  calendarCreateStop = (overtimeItem: OverTimeMonthModel): JSX.Element => {
    return (
      <OvertimeCardAppr sts={overtimeItem.apprSts} type={overtimeItem.overTimeType}>
        <OvertimeCardHeader>
          <div>
            {overtimeItem.overTimeType === 'OT'
              ? MobileLanguageHelper.getMessage('overtime.button.title.overtime')
              : overtimeItem.overTimeType === 'AB'
              ? MobileLanguageHelper.getMessage('overtime.button.title.alterbreak')
              : ''}
          </div>
        </OvertimeCardHeader>
        <PjCodeRender>{overtimeItem.pjCode}</PjCodeRender>
        <PjNameEllipsis>{overtimeItem.pjName}</PjNameEllipsis>

        <RenderHours type={overtimeItem.overTimeType} sts={overtimeItem.apprSts}>
          {overtimeItem.overtimeWorkHours}
        </RenderHours>
        <ApprStsRender sts={overtimeItem.apprSts}>
          {overtimeItem.apprSts === 'A'
            ? MobileLanguageHelper.getMessage('overtime.card.status.apprreq')
            : overtimeItem.apprSts === 'S'
            ? MobileLanguageHelper.getMessage('overtime.card.status.apprcomp')
            : ''}
        </ApprStsRender>
      </OvertimeCardAppr>
    );
  };

  renderUtilizationResult = (overtimeItem: OverTimeMonthModel): JSX.Element => {
    if (overtimeItem.apprSts === 'A' && overtimeItem.closing === 'N') {
      return this.calendarCreateInput(overtimeItem);
    } else {
      return this.calendarCreateStop(overtimeItem);
    }
  };

  render() {
    const { overtimeItem, onChangeHeaderVisible } = this.props;
    const currLanguage = StorageHelper.getItem(StorageHelper.KEY_CURR_LANGUAGE) === AppConst.LANG_ENUS ? AppConst.LANG_EN.toUpperCase() : AppConst.LANG_KO.toUpperCase();
    return (
      <>
        <Element name={overtimeItem.yyyymmdd} className="element">
          <Waypoint
            onEnter={({ previousPosition, currentPosition, event }) => {
              let visible = true;
              if (previousPosition === 'above') visible = true;
              if (previousPosition === 'below') visible = false;
              onChangeHeaderVisible(visible);
            }}
            topOffset="250px"
            bottomOffset="50%"
          >
            <CardWrapper id={'v' + moment(overtimeItem.yyyymmdd, 'YYYYMMDD').format('MMDD')}>
              <LeftDiv>
                <Date>
                  <YearMonthRender>
                    {moment(overtimeItem.yyyymmdd, 'YYYYMMDD').format('DD') === '01' ? moment(overtimeItem.yyyymmdd, 'YYYYMMDD').format('YYYY-MM') : ''}
                  </YearMonthRender>
                  <DateRender weekend={overtimeItem.holidayYn}>{moment(overtimeItem.yyyymmdd, 'YYYYMMDD').format('DD')}</DateRender>
                </Date>
                <WeekName>{currLanguage === AppConst.LANG_EN.toUpperCase() ? overtimeItem.weekEngName : overtimeItem.weekKorName}</WeekName>
              </LeftDiv>
              <RightDiv>{this.renderUtilizationResult(overtimeItem)}</RightDiv>
            </CardWrapper>
          </Waypoint>
        </Element>
        <Modal
          visible={this.state.modal}
          transparent
          maskClosable={false}
          onClose={() => this.onModalClose()}
          // title="Title"
          footer={[{ text: '확인', onPress: () => this.onModalClose() }]}
          // wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <div>{this.state.modalContents}</div>
        </Modal>
      </>
    );
  }
}
